import { useCallback, useEffect, useState } from "react";

const Slide2 = (props) => {

    const [slideStatus, setSlideStatus] = useState('1');


    const changeStatus = (e) => {
        let status = e.target.getAttribute('data-status')
        setSlideStatus(status)
    }

    
    return (
        <>

            <div className="slide2Cont">

                <div className="slide2Cont__info" >

                    <div className="slide2Cont__info__menuCont">
                        <div className="slide2Cont__info__menuCont__menu">
                            <button onClick={changeStatus} data-status="1" style={{ backgroundColor: slideStatus === '1' ? "#ffd204" : "transparent", color: slideStatus === '1' ? "#1a1a1a" : "#F1F1F1", fontWeight: slideStatus === '1' ? 700 : 400 }}>Bienvenue</button>
                            <button onClick={changeStatus} data-status="2" style={{ backgroundColor: slideStatus === '2' ? "#ffd204" : "transparent", color: slideStatus === '2' ? "#1a1a1a" : "#F1F1F1", fontWeight: slideStatus === '2' ? 700 : 400 }}>Structure</button>
                            <button onClick={changeStatus} data-status="3" style={{ backgroundColor: slideStatus === '3' ? "#ffd204" : "transparent", color: slideStatus === '3' ? "#1a1a1a" : "#F1F1F1", fontWeight: slideStatus === '3' ? 700 : 400 }}>Compétitif</button>
                        </div>
                    </div>

                    {slideStatus === '1' &&

                        <div className="slide2Cont__info__content">

                            <img className="onglet1img" src="/images/vitrine/slide2/laurier.png" alt="image d'illustration" />
                            <div className="slide2Cont__info__content__text">

                                <h2 className="hero glitch layers sousTitre" data-text="Qui sommes-nous?"><span>Qui sommes-nous?</span></h2>
                                <span>
                                    <p>
                                        La Force Coloniale Unifiée est une flotte de guerre francophone qui évolue et performe sur Star Citizen depuis 2019.
                                        Née du rassemblement et de l'investissement de joueurs aux profils variés,
                                        elle a pour objectif de relever les plus grands défis que Star Citizen offre et nous offrira dans le temps.
                                    </p>

                                    <p>
                                        Habituée des leaderboards PvP comme PvE, l'organisation se veut compétitive tout en restant accessible à tous
                                        et garantit à ses membres un environnement sain et une expérience de jeu unique.
                                    </p>

                                    <p>
                                        Grâce à l'expertise et à l'investissement de ses instructeurs, la FCU propose ;
                                    </p>

                                    <ul>
                                        <li>Formations de qualité ainsi qu'un suivi personnalisé de ses membres.</li>
                                        <li>Des entraînements et des événements structurés visant à faire progresser le collectif.</li>
                                        <li>Des défis inédits à relever chaque semaine.</li>
                                    </ul>

                                    <p>
                                        Neutre et autonome, l'organisation orientera ses alliances autour de ses propres intérêts et de ses affinités
                                        tout en offrant un large éventail de gameplays pour une expérience de jeu la plus complète possible.
                                    </p>
                                </span>
                                <h4 className=" sousTitre marginTop" data-text="En quelques chiffres"><span>En quelques chiffres</span></h4>
                                <div className="chiffresCont">
                                    <div>
                                        <p>Evènements realisé</p>
                                        <span>1369</span>
                                    </div>
                                    <div>
                                        <p>Membres</p>
                                        <span>500</span>
                                    </div>
                                    <div>
                                        <p>Date de création</p>
                                        <span>2019</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                    }

                    {slideStatus === '2' &&

                        <div className="slide2Cont__info__content">

                            <img className="onglet2img" src="/images/vitrine/slide2/armes.webp" alt="image d'illustration" />
                            <div className="slide2Cont__info__content__text">

                                <h2 className="hero glitch layers sousTitre" data-text="Un collectif actif et structuré"><span>Un collectif actif et structuré</span></h2>
                                <h4 className="hero glitch layers sousTitre" data-text="Des instructeurs et encadrants passionés."><span>Des instructeurs et encadrants passionés.</span></h4>

                                <p>
                                    En tant qu'organisation structurée, compétitive et méritocratique, nos encadrants se doivent d'être compétents, actifs et passionnés.
                                </p>

                                <p>
                                    Star Citizen étant un jeu dont le développement prend beaucoup de temps,
                                    la motivation et les disponibilités des joueurs évoluent donc naturellement au fil des années.
                                    Pour garantir à nos membres le meilleur encadrement possible, nous effectuons une rotation des encadrants plusieurs fois par an,
                                    permettant ainsi aux joueurs les plus motivés, disponibles et compétents de prendre la place qui leur revient.
                                </p>

                                <p>
                                    Nous évitons ainsi l'accumulation de joueurs inactifs conservant des attributions ou des rangs qui ne correspondent plus à leur investissement.
                                    Au sein de la FCU, <strong>chaque membre doit mériter la place qui est la sienne</strong>.
                                </p>
{/* 
                                <div className="chiffresCont">
                                    <div>
                                        <p>Chefs de Groupe</p>
                                        <span>7</span>
                                    </div>
                                    <div>
                                        <p>Chefs de Division</p>
                                        <span>4</span>
                                    </div>
                                    <div>
                                        <p>Officiers</p>
                                        <span>5</span>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    }
                    {slideStatus === '3' &&

                        <div className="slide2Cont__info__content">

                            <img className="onglet3img" src="/images/vitrine/slide2/soldat.webp" alt="image d'illustration" />
                            <div className="slide2Cont__info__content__text">

                                <h2 className="hero glitch layers sousTitre" data-text="Structure hardcore"><span>Structure hardcore</span></h2>
                                <h4 className="hero glitch layers sousTitre" data-text="Compétition et leaderboards."><span>Compétition et leaderboards.</span></h4>

                                <p>
                                    Si la FCU est une organisation ouverte à tous, elle n'en reste pas moins une structure compétitive ambitieuse.
                                    A sa mesure, Star Citizen offre à sa communauté un environnement compétitif via Star Marine et l'Arena Commander
                                    et ce, depuis des années. Vu les ambitions qui sont les nôtres dans l'univers de Star Citizen,
                                    il nous a toujours semblé logique de monter des équipes compétitives FCU pour participer aux tournois
                                    organisés par la communauté ou relever les défis in-game que nous propose et proposeront les développeurs.
                                </p>
                                <p>
                                    L'expérience recueillie lors de ces compétitions
                                    a toujours été un atout formidable nous permettant d'optimiser nos plans de jeu pour l'ensemble de la structure.
                                    Bien que le niveau de certaines de ces compétitions soit très élevé, pour le moment,
                                    elles restent dans le domaine du "grand loisir"
                                    car le jeu et ses mécaniques sont encore loin d'être adaptés à un véritable aspect compétitif.
                                </p>
                                <p>
                                    Cependant, vu la volonté de la communauté à faire vivre cette dimension du jeu,
                                    nous sommes persuadés que nous ne sommes qu'au début de cette belle aventure.
                                    Et comme pour tout ce que nous entreprenons, nous comptons bien nous faire remarquer dans la discipline.
                                    Avis aux amateurs !
                                </p>
                               
                            </div>
                        </div>
                    }
                    {slideStatus === '4' &&

                        <div className="slide2Cont__info__content">

                            <img src="../../images/vitrine/Slide2/armes.png" alt="image d'illustration" />
                            <div className="slide2Cont__info__content__text">
                                <h2>Un contenu original</h2>
                                <h4>Des quetes, des recompenses et bien plus!</h4>

                                <p>Complete Family (12 Fonts) Borda is a carefully designed geometric typeface, combining precise angles with smooth corner details to achieve a clean and futuristic aesthetic. Its mechanical design imparts a contemporary feel, making it well-suited for screen-based designs. Characterised by compact l</p>
                            </div>
                        </div>
                    }

                </div>

            </div>

        </>
    );
};

export default Slide2;
